/**
 * @description 小鈴鐺頁面Modal名稱
 * @enum {string} SEARCH_SETTINGS 篩選設定Modal
 */
export enum HintBellModalName {
    HINT_BELL = 'HINT_BELL'
}

/**
 * @description 小鈴鐺頁面Modal的Modal名稱
 * @enum {string} SEARCH_SETTINGS 篩選設定Modal
 */
export enum ModalHintBellModalName {
    SEARCH_SETTINGS = 'SEARCH_SETTINGS'
}

// 小鈴鐺頁面Modal搜索條件欄位設定物件
export const messageSearchFields = {
    valid_date_start: { title: '生效日期起', fieldtype: 'date' },
    valid_date_end: { title: '生效日期迄', fieldtype: 'date' },
    subject: { title: '主題', fieldtype: 'text' },
}

/**小鈴鐺通知類型 */
export enum HintType {
    /**人事相關簽核通知*/
    HR = "人事",
    /**公文簽核通知*/
    SIGN_OFF = "簽核",
    /**PDI */
    PDI = "PDI",
    /**公佈欄通知 */
    BULLTIN = "公佈欄",
    /**知悉通知 */
    NOTICE = "知悉通知",
}